import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppError } from 'app/common/app-error';
import { UserCredentials } from 'domain-models/UserCredentials';
import { environment } from 'environments/environment';
import { Helper } from 'libraries/Helper';
import { ConfirmationService } from 'primeng/primeng';
import { AuthService } from 'services/auth/auth.service';
import { UserIdleService } from 'services/user-idle/user-idle.service';
declare var msal: any; //this is set from the CDN
declare var $: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
	msalInstance = new msal.PublicClientApplication(environment.azureAD.msalConfig); //instantiate msal
	p: string;
	loading: boolean;
	visibilityOfMessage: boolean;
	ngOnInit(): void {
		this.authService.IsLoggedIn();
		this.setTimerBasedOnToken();
		// console.log("--------------------------This is being called again!!!");
	}

	setTimerBasedOnToken() {
		let writeTokenDate = this.authService.getTokenExpiration('token');
		let readTokenDate = this.authService.getTokenExpiration('readToken');
		// Weird check here because we can return false from getTokenExpiration
		if (readTokenDate && writeTokenDate !== false) {
			var currentTime = new Date();

			//var timeLeft=tokenDate.getTime()-currentTime.getTime();
			var expiration = readTokenDate.getTime();
			console.log(expiration);
			//if(timeLeft>60000){
			//this.userIdleService.setTimer(timeLeft-60000,this.timerTick.bind(this));
			this.userIdleService.setIddleService(
				readTokenDate,
				writeTokenDate,
				this.timerTick.bind(this)
			);
			//* Uncomment this next line if you wanna just setup a 20s timeout
			// this.userIdleService.setIddleService(new Date(Date.now()+20000), this.timerTick.bind(this));
			//this.userIdleService.inactivityTimer=new Timer(7000,this.timerTick.bind(this));
			this.userIdleService.start();
			//}else{
			// this.timerTick();
			//}
		}
	}

	constructor(
		public authService: AuthService,
		public confirmationService: ConfirmationService,
		public userIdleService: UserIdleService,
		private router: Router
	) {
		this.authService.onLogStatusChanged.subscribe((status) => {
			if (status) this.setTimerBasedOnToken();
			else this.userIdleService.stop();
		});
	}

	counter = 0;
	timerTick(): any {
		this.userIdleService.waitingAuth = true;
		this.userIdleService.stop();
		this.confirmationService.confirm({
			key: 'login',
			message: '',
			accept: () => {},
			reject: () => {
				console.log(this.userIdleService.readTimeLeft);
				if (this.userIdleService.readTimeLeft === 'expired') {
					this.authService.logout();
				}
			}
		});
		// Helper.alert("Hello");
		// this.counter++;
		// if(this.counter>5){
		//   this.counter=0;
		//   this.inactivityTimer.stop();
		// }
	}

	/**
	 * Handle accept for the timeout confirmation dialogue
	 * @param confirmDialog
	 */
	accept(confirmDialog) {
		var credentials = new UserCredentials();
		credentials.username = this.authService.currentUser.username;
		credentials.password = this.p;
		var salt;
		if (credentials.username) {
			//this.authService.getSalt(credentials.username)
			//.subscribe(result => {
			//salt = result.Salt;
			//credentials.password = Crypto.HashWithBase64Salt(credentials.password, salt);

			this.authService.login(credentials).subscribe(
				(result) => {
					if (result) {
						Helper.alert('You can continue', 2);
						this.p = '';
					} else {
						Helper.alert("We could not verify it's you");
						this.authService.logout();
					}
					this.loading = false;
					this.userIdleService.waitingAuth = false;
					confirmDialog.accept(result);
				},
				(error: AppError) => {
					Helper.alert("We could not verify it's you");
					this.authService.logout();
					confirmDialog.reject();
				}
			);
			// },
			// (error: AppError) => {
			//   Helper.alert("We could not verify it's you");
			//   this.authService.logout();
			//   confirmDialog.reject();
			//   this.loading = false;
			// });
		}
	}
	/**
	 * handle reject for the timeout confirmation dialogue
	 * @param confirmDialog
	 */
	reject(confirmDialog) {
		const expiration = this.authService.getTokenExpiration('readToken');
		const currentRoute = this.router.url;
		if (expiration && currentRoute.includes('display')) {
			//read token is still active and user is on display page
			//so dont log him out just yet
			confirmDialog.reject();
		} else {
			this.authService.logout();
			this.userIdleService.waitingAuth = true;
			confirmDialog.reject();
		}
	}

	/**
	 * Handle accept for badwords confirmation dialogue
	 * @param confirmDialog
	 */
	acceptBadWords(confirmDialog) {
		var credentials = new UserCredentials();
		credentials.username = this.authService.currentUser.username;
		credentials.password = this.p;
		var salt;
		if (credentials.username) {
			this.authService.login(credentials).subscribe(
				(result) => {
					if (result) {
						Helper.alert('Retrying the sign request', 2);
						this.p = '';
					}
					this.loading = false;
					this.userIdleService.waitingAuth = false;
					confirmDialog.accept(result);
				},
				(error: AppError) => {
					Helper.alert("We could not verify it's you");
					confirmDialog.reject();
				}
			);
		}
	}

	/**
	 * Reject for badwords confirmation dialogue, simply closes the dialogue
	 * @param confirmDialog
	 */
	rejectBadWords(confirmDialog) {
		confirmDialog.reject();
	}

	async ssoLogin(confirmDialog) {
		try {
			let ssoLoginResponse = await this.msalInstance.loginPopup(environment.azureAD.loginRequest);
			let result = await this.authService.ssoLogin(ssoLoginResponse.accessToken);
			if (result) {
				Helper.alert('You can continue', 2);
				confirmDialog.accept();
			}
		} catch (error) {
			Helper.alert("We could not verify it's you");
			this.authService.logout();
		}
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/app.component.ts